export default "__VITE_ASSET__Bk7z1F5t__"